import { Col } from "react-bootstrap";
import { useCookiesContext } from "../../../../../contexts/CookiesContext";
import { creditsLackAlertLabels } from "@revbox/localization";

export default function CreditsLackAlert({
  isCreditBalanceSmallerThanTopBid,
  closedAlert,
  setClosedAlert,
}) {
  const { getLanguageAbbr } = useCookiesContext();
  const languageAbbr = getLanguageAbbr();
  const { title, message } = creditsLackAlertLabels[languageAbbr];
  return (
    isCreditBalanceSmallerThanTopBid ? (
        !closedAlert ? (
          <Col md="12">
            <div className="fade alert alert-dismissible danger-system-alert show mb-0">
              <button
                type="button"
                className="btn-close"
                aria-label="Close alert"
                onClick={() => setClosedAlert(true)}
              ></button>
              <div className="banner">
                <h3 className="banner-title">
                  {title}
                </h3>
                <p className="banner-text">
                  {message}
                </p>
              </div>
            </div>
          </Col>
        ) : (
          <></>
        )
      ) : (
        <></>
      )
  );
}